import styled from 'styled-components';
import { BaseSection } from '../components/styles';
import { BaseDivHomePage } from '@/main/components/layouts/homepageLayout/styles';

interface IFirstSectionProps {
  $backgroundImage: string;
}

export const Container = styled(BaseDivHomePage)`
  #id-homepage-privacyPolicy-image-2 {
    object-fit: cover;
    object-position: 69%;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
      height: 350px;
    }
  }
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const FirstSection = styled(BaseSection)<IFirstSectionProps>`
  background-image: url(${props => props.$backgroundImage});
  background-position: left;
  background-size: 570px 380px;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.white};
  text-align: center;
  padding-top: 1rem;
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    max-width: 100%;
    height: auto;
    background-size: 440px;
    background-position-x: -6px;
    background-position-y: 515px;
    padding: 0px;
  }
`;

export const TextContainer = styled.div`
  text-align: start;
  font-weight: 100;
  font-size: large;
  padding-bottom: 100px;
`;
